var _path, _g, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 129,
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22716_571365",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 128,
    height: 128
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 0H0V128H128V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22716_571365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 128C99.3462 128 128 99.3462 128 64C128 28.6538 99.3462 0 64 0C28.6538 0 0 28.6538 0 64C0 99.3462 28.6538 128 64 128Z",
    fill: "#E4E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0001 36.1739C56.7097 36.1739 50.7827 42.1009 50.7827 49.3913C50.7827 56.5426 56.3758 62.3304 63.6662 62.5809C63.8888 62.553 64.1114 62.553 64.2784 62.5809C64.334 62.5809 64.3618 62.5809 64.4175 62.5809C64.4453 62.5809 64.4453 62.5809 64.4731 62.5809C71.5966 62.3304 77.1897 56.5426 77.2175 49.3913C77.2175 42.1009 71.2905 36.1739 64.0001 36.1739Z",
    fill: "#5A7FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1384 69.9851C70.3749 64.8095 57.714 64.8095 49.8949 69.9851C46.361 72.3503 44.4131 75.5503 44.4131 78.9729C44.4131 82.3955 46.361 85.5677 49.8671 87.9051C53.7627 90.5208 58.8827 91.8286 64.0027 91.8286C69.1227 91.8286 74.2427 90.5208 78.1384 87.9051C81.6444 85.5399 83.5923 82.3677 83.5923 78.9173C83.5644 75.4947 81.6444 72.3225 78.1384 69.9851Z",
    fill: "#5A7FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7689 50.3819C92.1468 55.6458 88.8884 60.2585 84.3789 60.8826C84.3552 60.8826 84.3552 60.8826 84.3316 60.8826H84.2606C84.119 60.8826 83.9774 60.8826 83.8594 60.9369C81.569 61.0724 79.4676 60.2315 77.8857 58.6847C80.3177 56.1884 81.7106 52.4441 81.4274 48.374C81.2621 46.1763 80.6009 44.1684 79.6095 42.459C80.5066 41.9434 81.5454 41.6178 82.608 41.5093C87.2358 41.0482 91.3677 45.0095 91.7689 50.3819Z",
    fill: "#5A7FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2036 50.6482C35.8257 55.9121 39.0841 60.5248 43.5939 61.1489C43.6176 61.1489 43.6176 61.1489 43.6409 61.1489H43.7119C43.8535 61.1489 43.9952 61.1489 44.1132 61.2032C46.4035 61.3387 48.5049 60.4978 50.0869 58.951C47.6549 56.455 46.2619 52.7104 46.5452 48.6403C46.7104 46.4426 47.3716 44.4346 48.3633 42.7253C47.4659 42.2097 46.4272 41.8841 45.3648 41.7756C40.737 41.3145 36.6051 45.2758 36.2036 50.6482Z",
    fill: "#5A7FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3375 76.2883C97.143 79.2657 95.6354 81.8438 93.1068 83.5935C90.6754 85.2814 87.6117 86.0794 84.5723 85.9873C86.3231 83.9925 87.344 81.5062 87.5388 78.8666C87.7817 75.0606 86.3473 71.4081 83.4782 68.4922C81.8489 66.8655 79.9526 65.5766 77.8857 64.625C83.2594 62.6607 90.0187 63.9805 94.1767 68.2162C96.4137 70.4874 97.5562 73.3418 97.3375 76.2883Z",
    fill: "#5A7FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6349 76.5546C30.8294 79.532 32.3371 82.1101 34.8659 83.8598C37.2973 85.5477 40.361 86.3457 43.4001 86.2536C41.6496 84.2588 40.6284 81.7725 40.4339 79.1329C40.1907 75.3269 41.6251 71.6744 44.4943 68.7585C46.1235 67.1318 48.0201 65.8429 50.0868 64.8913C44.7133 62.927 37.9537 64.2468 33.796 68.4825C31.559 70.7537 30.4162 73.6081 30.6349 76.5546Z",
    fill: "#5A7FFF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.589 123.383C115.216 123.383 120.589 118.01 120.589 111.383C120.589 104.756 115.216 99.383 108.589 99.383C101.962 99.383 96.5889 104.756 96.5889 111.383C96.5889 118.01 101.962 123.383 108.589 123.383Z",
    fill: "#A7BBFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.096 118.05H112.083C113.923 118.05 115.003 117.009 115.089 115.636V109.71C115.183 108.27 114.036 107.716 112.589 107.716C112.183 107.716 111.809 107.483 111.623 107.123L111.143 106.156C110.836 105.55 110.036 105.05 109.356 105.05H107.829C107.143 105.05 106.343 105.55 106.036 106.156L105.556 107.123C105.369 107.483 104.996 107.716 104.589 107.716C103.143 107.716 101.996 108.27 102.089 109.71V115.636C102.169 117.009 103.256 118.05 105.096 118.05Z",
    stroke: "#1A1A1A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.589 108.716H109.589",
    stroke: "#1A1A1A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.589 115.383C109.782 115.383 110.755 114.41 110.755 113.216C110.755 112.023 109.782 111.05 108.589 111.05C107.395 111.05 106.422 112.023 106.422 113.216C106.422 114.41 107.395 115.383 108.589 115.383Z",
    stroke: "#1A1A1A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupProfile);
export default __webpack_public_path__ + "static/media/groupProfile.b4a246146424ae029c6e9a9eb92025a7.svg";
export { ForwardRef as ReactComponent };